import React from 'react';
interface PriceDeltaBarProps {
  value: number; // percentage difference
  className?: string;
}
export function PriceDeltaBar({
  value,
  className = ''
}: PriceDeltaBarProps) {
  // Clamp value between -20 and 20 for visual representation
  const clampedValue = Math.max(-20, Math.min(20, value));
  // Calculate position (0 to 100%)
  // -20% -> 0%
  // 0% -> 50%
  // +20% -> 100%
  const position = (clampedValue + 20) / 40 * 100;
  let colorClass = 'bg-slate-400';
  if (value < -5) colorClass = 'bg-emerald-500';else if (value > 5) colorClass = 'bg-red-500';else colorClass = 'bg-amber-500';
  return <div className={`w-32 ${className}`} data-id="element-273">
      <div className="flex justify-between text-[10px] text-slate-400 mb-1 font-medium" data-id="element-274">
        <span data-id="element-275">-20%</span>
        <span data-id="element-276">0%</span>
        <span data-id="element-277">+20%</span>
      </div>
      <div className="h-2 bg-slate-100 rounded-full relative overflow-hidden" data-id="element-278">
        {/* Center marker */}
        <div className="absolute left-1/2 top-0 bottom-0 w-0.5 bg-slate-300 transform -translate-x-1/2 z-10" data-id="element-279" />

        {/* Value bar */}
        <div className={`absolute top-0 bottom-0 rounded-full transition-all duration-500 ${colorClass}`} style={{
        left: value < 0 ? `${position}%` : '50%',
        right: value > 0 ? `${100 - position}%` : '50%'
      }} data-id="element-280" />
      </div>
      <div className={`text-xs font-bold text-center mt-1 ${value < -5 ? 'text-emerald-600' : value > 5 ? 'text-red-600' : 'text-amber-600'}`} data-id="element-281">
        {value > 0 ? '+' : ''}
        {value}%
      </div>
    </div>;
}